/** @jsx jsx */
import { jsx, Flex, Box } from 'theme-ui'

// import { Img } from 'gatsby-image'
import Paragraph from '../../components/shared/Typography/Paragraph/Paragraph'

import ContentfulRichText from '../shared/Contentful/RichText'
import Body from '../shared/Typography/Body/Body'
import { BLOCKS } from '@contentful/rich-text-types'

const IconTextBlock = props => {
  return (
    <Flex variant="footerBox" {...props}>
      <Box sx={{ textAlign: 'center', px: 20 }}>
        {props.icon && (
          <img
            sx={{ width: '42px', margin: 'auto', mb: 20 }}
            src={props.icon}
            alt="icon"
          />
        )}
        <Paragraph
          variant="iconBlockHeader"
          sx={{
            margin: '10px',
          }}
        >
          {props.text}
        </Paragraph>
        {props.description && (
          <ContentfulRichText
            customOptions={{
              [BLOCKS.PARAGRAPH]: (node, children) => (
                <Body sx={{ maxWidth: '450px' }} variant="captionLarge">
                  {children}
                </Body>
              ),
            }}
            text={props.description}
          />
        )}
      </Box>
    </Flex>
  )
}
export default IconTextBlock
